import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import {
  selectClimateMinMax,
  selectHistoricalChartData,
  selectClimateCsvData
} from '../../../store/data/data.selector';
import {
  selectAttributeId,
  selectAttributeInfo,
  selectDateRange,
} from '../../../store/options/options.selector';
import { selectCurrentLocation, selectCurrentStation, selectUseStationData } from '../../../store/map/map.selector';

import downloadData from '../../../utilities/downloadData';

import { getAttributeText } from '../../../utilities/mapPopupText';

export default function HistoricalChart({
  HighchartsReact,
  Highcharts,
  defaultOptions,
}) {
  const data = useSelector(selectHistoricalChartData);
  const csvData = useSelector(selectClimateCsvData);
  const attr = useSelector(selectAttributeId);
  const attrInfo = useSelector(selectAttributeInfo);
  const loc = useSelector(selectCurrentLocation);
  const dateRange = useSelector(selectDateRange);
  const minMax = useSelector(selectClimateMinMax);
  const useStation = useSelector(selectUseStationData);
  const currentStation = useSelector(selectCurrentStation);

  let { attrName, unit, popupUnit } = getAttributeText(true, attr);

  let title;
  if (useStation) {
    title = `${attrName} at ${currentStation.name} from ${dateRange.start} to ${dateRange.end}`;
  } else {
    title = `${attrName} in ${loc.state ? `${loc.name} County, ${loc.state}` : loc.name} from ${dateRange.start} to ${dateRange.end}`;
  }

  const options = {
    ...defaultOptions,
    title: {
      ...defaultOptions.title,
      text: title,
    },
    exporting: {
      ...defaultOptions.exporting,
      menuItemDefinitions: {
        downloadData: {
          onclick: () => downloadData(
            'climate',
            loc,
            attrInfo,
            csvData,
            dateRange
          ),
          text: 'Download Chart Data',
        },
      },
    },
    series: [{ data: data, name: attrName }],
    yAxis: {
      gridLineColor: '#a1a1a1',
      title: {
        text: unit,
      },
      min: minMax.min,
      max: minMax.max,
      gridLineWidth: data.length ? 1 : 0,
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.x}</b><br/>${attrName}: <b>${this.y.toFixed(
          2
        )} ${popupUnit}</b>`;
      },
    },
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ style: { height: '100%', width: '100%' } }}
    />
  );
}

HistoricalChart.propTypes = {
  HighchartsReact: PropTypes.object,
  Highcharts: PropTypes.object,
  defaultOptions: PropTypes.object,
};
